import { HttpErrorResponse, HttpHeaders,HttpClient } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';

import { environment } from 'src/environments/environment';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-exam-stream-data',
  templateUrl: './exam-stream-data.component.html',
  styleUrls: ['./exam-stream-data.component.scss']
})
export class ExamStreamDataComponent implements OnInit {
  examStreamForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  deleteButton=false;
  list;
  exStreamList: any;
  coCodeList: any;
  filteredListCoCode: any;
  examIdList: any;
  filteredListExamId: any;
  x = sessionStorage.getItem('CoCode');
  y = sessionStorage.getItem('CoName');
  examStreamCourseList: any;
  filteredListExamStreamCode: any;
  dialogRef: MatDialogRef<any>;
  APIService: any;
  isDivShow= false;
  updateReadOnly=false;
  deleateReadOnly=false;
  userPermission: any;
  CourseBranchCreate = true;
  CourseBranchUpdate = true;
  CourseBranchDelete = true;
  userTypee: string;
  branchView = true;
  uType: any;
  user: any;
  utp: any;
  @Output() prev = new EventEmitter<void>();
  
  constructor(public umsService: UmsService,
              private modalPopupService: ModalpopService,private httpClient: HttpClient,
              private fb: FormBuilder,   public router: Router,
              private route: ActivatedRoute, private spinner:NgxSpinnerService) { this.APIService = environment.serviceUrl;}

  ngOnInit(): void {
    this.x = sessionStorage.getItem('CoCode');
    this.y = sessionStorage.getItem('CoName');
    this.updateReadOnly=false;
    this.deleateReadOnly=false;
    this.y = sessionStorage.getItem('CoName');    
    this.submitButton = true;
    this.editButton = false;
    this.deleteButton=false;
    this.list = true;
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');

    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      this.userPermission.forEach(element => {
        if (element.PageName == 'Branch/Stream' && element.PCreate == false) {
          this.CourseBranchCreate = false;
        }
        if (element.PageName == 'Branch/Stream' && element.PUpdate == false) {
          this.CourseBranchUpdate = false;
        }
        if (element.PageName == 'Branch/Stream' && element.PDelete == false) {
          this.CourseBranchDelete = false;
        }
      });
    }
    this.examStreamForm = this.fb.group({
      StrId: new FormControl (''),
      StrCoCode: new FormControl (this.x),
      courseName:new FormControl (this.y),
      StrCode: new FormControl ('', [Validators.required, Validators.pattern('^[a-zA-z0-9- &\\s]*$')]),
      StrName: new FormControl ('', [Validators.required]),
      StrActive: new FormControl ('Y'),
      StrSpFlag: new FormControl ('', [Validators.required, Validators.pattern('^[a-zA-z0-9- &\\s]*$')]),
      StrPassCr: new FormControl ('', [Validators.required, Validators.pattern("^[0-9.]*$")]),
      // CoCode: new FormControl (''),
      // EmId: new FormControl ('0'),
    });
    this.getExamStreamData()
  }

  getExamStreamData() {
    const payload = {};
  payload['CoCode'] = this.x;
  payload['EmId'] = 0;
    this.umsService.getExamStream(payload).subscribe(res => {
      this.exStreamList = res.data;
      if(res.data.length==0){
        this.isDivShow = false;
      }
      else{
        this.isDivShow = true;
      }
      },(ERROR: HttpErrorResponse) => {
        this.exStreamList = [];
        if(this.exStreamList.length==0){
          this.isDivShow = false;
        }
        else{
          this.isDivShow = true;
        }
        // alert(ERROR);
      });
  }
  addnewrecord(e){
    if (e === 'true'){
      this.list = false;
      this.deleateReadOnly=false;
      this.editButton = false;
      this.submitButton = true;
      this.deleteButton=false;
      this.updateReadOnly=false;
      this.examStreamForm.reset();
    } else {
      this.list = true;
      this.ngOnInit();
    }
  }

  submit(){
    if (this.examStreamForm.invalid) {
      this.examStreamForm.get('StrCode').markAsTouched();
      this.examStreamForm.get('StrName').markAsTouched();
      this.examStreamForm.get('StrActive').markAsTouched();
      this.examStreamForm.get('StrSpFlag').markAsTouched();
      this.examStreamForm.get('StrPassCr').markAsTouched();
      return;
    } else {
      this.saveExamStream();
    }
  }
  saveExamStream() {
    this.spinner.show();
    const payload = this.examStreamForm.value;
    this.umsService.submitExamStream(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        let data = {};
        data['message'] = res.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
              } else {
        let data = {};
        data['message'] = res.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
          this.ngOnInit();
        // });
      }
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        
      });
  }

  editdata(e,k){
    if (e === 'true'){
      this.list = false;
      // this.getExamStreamData();
      this.prepopulation(k);
    } else {
      this.list = true;
    }
  }
  prepopulation(id) {
    this.updateReadOnly=true;
    this.deleateReadOnly=false;
         this.editButton = true;
         this.submitButton = false;
         this.deleteButton=false;
         this.examStreamForm = this.fb.group({
          StrId: new FormControl (id.StrId),
          StrCoCode: new FormControl (id.StrCoCode),
          StrCode: new FormControl (id.StrCode, [Validators.required, Validators.pattern('^[a-zA-z0-9- &\\s]*$')]),
          StrName: new FormControl (id.StrName, [Validators.required]),
          StrActive: new FormControl (id.StrActive),
          StrSpFlag: new FormControl (id.StrSpFlag, [Validators.required,Validators.pattern('^[a-zA-z0-9- &\\s]*$')]),
          StrPassCr: new FormControl (id.StrPassCr, [Validators.required,Validators.pattern("^[0-9.]*$")]) 
         })
  }

  
  update(){
    if (this.examStreamForm.invalid) {
      this.examStreamForm.get('StrCode').markAsTouched();
      this.examStreamForm.get('StrName').markAsTouched();
      this.examStreamForm.get('StrActive').markAsTouched();
      this.examStreamForm.get('StrSpFlag').markAsTouched();
      this.examStreamForm.get('StrPassCr').markAsTouched();
      return;
    } else {
      this.updateExamStream();
    }
  }

  updateExamStream() {
    this.spinner.show();
    // 403 code error handling needed to be given
    this.submitpayload = this.examStreamForm.value;
    this.umsService.updateExamStream(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status){
        const  data = {};
        data['message'] = res.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.getExamStreamData();
      } else {
        const  data = {};
        data['message'] = res.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();
      // this.umsService.openSnackbar(ERROR.error.message);
  
    });
  }

  deletedata(id){
    this.spinner.show()
    const options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),  body: {
  StrId: id.StrId,
  StrCoCode: this.x,
  StrCode:id.StrCode,
  StrName: id.StrName,
  StrActive: id.StrActive,
  StrSpFlag:  id.StrSpFlag,
  StrPassCr:id.StrPassCr,
    },
  };
  this.httpClient.delete(this.APIService + '/masters/exam-stream/branch', options)
  .subscribe((s) => {
    this.spinner.hide();
    let cc = [];
    cc.push(s);
    let data = {};
    data['message'] = cc[0].message;
    data['title'] = 'Information';
    data['icon'] = 'fas fa-check';
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      ///this.getExamStreamData()
       this.ngOnInit();
    });
  }, (ERROR: HttpErrorResponse) => {
    this.spinner.hide();
    let data = {};
    data['message'] = ERROR.error.message;
    data['title'] = 'Alert';
    data['icon'] = 'fas fa-close';
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    this.ngOnInit();
    // this.umsService.openSnackbar(ERROR.error.message);

  });
   }
   download(){
    const wwe = ['', ''];
    this.umsService.downloadFile(this.exStreamList, 'jsontocsv', wwe);
  }

  prepopulationForDelete(id){
    this.deleateReadOnly = true;
    this.updateReadOnly = false;
    this.editButton = false;
    this.submitButton = false;
    this.deleteButton=true;
    this.examStreamForm = this.fb.group({
     StrId: new FormControl (id.StrId),
     StrCoCode: new FormControl (id.StrCoCode),
     StrCode: new FormControl (id.StrCode, [Validators.required, Validators.pattern('^[a-zA-z0-9- &\\s]*$')]),
     StrName: new FormControl (id.StrName, [Validators.required]),
     StrActive: new FormControl (id.StrActive),
     StrSpFlag: new FormControl (id.StrSpFlag, [Validators.required, Validators.pattern('^[a-zA-z0-9- &\\s]*$')]),
     StrPassCr: new FormControl (id.StrPassCr, [Validators.required, Validators.pattern("^[0-9.]*$")]) 
   });
  }

  back(){   
     this.prev.emit();
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  deletee(e, k){
    if (e === 'true'){
      this.list = false;
     this.prepopulationForDelete(k);
    } else {
      this.list = true;
    }
  }

  openConformationModalBox(){
    const  data = {};
    data['message'] = 'Are You Sure You Want To Delete This Record ?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes'){
        this.deletedata(this.examStreamForm.value);
      }
    });
   }

  
   
}
